import GenericModal from "components/generic-modal";
import * as S from './styled';
import intl from "react-intl-universal";
import Button from "components/button";
import { useOrderVolumeContext } from "features/order-volume/context";
import { SelectBox } from "components/uikit-adapter";
import { useState } from "react";
import { IJustification } from "types/justification";
import TextArea from "components/textarea";
import { IAdditionalDataForRefusal } from ".";
import { useGlobalContext } from "hooks/useGlobalContext";

interface IModalConfirmRefusalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (additionalDataForRefusal: IAdditionalDataForRefusal) => void
}

const ModalConfirmRefusal = ({ open, onClose, onConfirm }: IModalConfirmRefusalProps) => {
  const { justifications } = useOrderVolumeContext();
  const { showFeedback } = useGlobalContext();
  const [selectedJustification, setSelectedJustification] = useState<number | null>(null);
  const [note, setNote] = useState<string | null>(null);

  const handleClickConfirm = () => {
    if(!selectedJustification) {
      showFeedback(intl.get('feedbacks.messageMandatoryJustification'));
    } else {
      const additionalData = {
        Observacao: note,
        TypeJustificationSuggestionManual: selectedJustification
      }
      onConfirm(additionalData);
    }
  }

  return (
    <GenericModal 
      open={open} 
      onRequestClose={onClose}
      modalStyle={{ width: '40%' }}
    >
      <S.ModalTitle>{intl.get('volumeOrders.confirmVolumesRefusal')}</S.ModalTitle>
      <S.ModalContent>
        <S.ModalText>{intl.get('volumeOrders.confirmVolumesRefusalMesage')}</S.ModalText>
        <SelectBox 
          name="justifications"
          label={intl.get('commons.justification')}
          placeholder={intl.get('commons.justification')}
          className="justifications-selectbox"
          valueKey="Key"
          labelKey="Value"
          options={justifications}
          value={selectedJustification}
          onChange={(value: IJustification) => setSelectedJustification(value?.Key)}
          required
          data-testid="justifications-selectbox"
        />
        <TextArea 
          label={intl.get('commons.Observation')}
          value={note ?? ''}
          onChange={(e) => setNote(e.target.value)}
          data-testid="textarea-observation"
        />
      </S.ModalContent>
      <S.ModalActions>
        <Button 
          onClick={onClose} 
          style={{ margin: 0 }}
          value={intl.get('geral.buttonsDefault.cancel')}
        />
        <Button 
          onClick={handleClickConfirm} 
          style={{ margin: 0 }} 
          buttonType="primary"
          value={intl.get('geral.buttonsDefault.confirm')}
        />
      </S.ModalActions>
    </GenericModal>
  )
}

export default ModalConfirmRefusal;